import Icon from '../../icon';

export default function ViewOnlyLabel() {
  return (
    <div className="view-only-label u-hide-from-sm">
      <Icon.Info />
      View-only PDF
    </div>
  );
}
